import PropTypes from 'prop-types';
import { connectComponent } from '../../lib/connectComponent';
import { getAsset } from '../../selectors/assets';

import AssetDetailsHeader from '../../components/assets/AssetDetailsHeader/AssetDetailsHeader';

import Asset from '../../entities/asset';
import { LocationPropType } from '../../types/history';

export const AssetDetailsHeaderContainer = ( {
	asset, projectID
} ) => (
	<AssetDetailsHeader
		asset={asset}
		projectID={projectID}
	/>
);

AssetDetailsHeaderContainer.propTypes = {
	asset: PropTypes.instanceOf( Asset ),
	location: LocationPropType.isRequired,
	projectID: PropTypes.number
};

AssetDetailsHeaderContainer.defaultProps = {
	asset: null,
	projectID: undefined
};

export default connectComponent( ( state, props ) => ( {
	asset: getAsset( state, props )
} ) )( AssetDetailsHeaderContainer );
